export default [
  {
    path: "/content-pages",
    component: () =>
      import(/* webpackChunkName: "content-pages" */ "@/views/Content/pages"),
    children: [
      {
        path: "/",
        name: "ContentPages",
        component: () =>
          import(
            /* webpackChunkName: "content-pages" */ "@/views/Content/pages/Content"
          ),
      },
      {
        path: "register-content-specialty",
        name: "RegisterContentSpecialty",
        component: () =>
          import(
            /* webpackChunkName: "content-pages" */ "@/views/Content/pages/Specialties/Register"
          ),
      },
      {
        path: "list-content-specialties",
        name: "ListContentSpecialties",
        component: () =>
          import(
            /* webpackChunkName: "content-pages" */ "@/views/Content/pages/Specialties/List"
          ),
      },
      {
        path: ":id/edit-content-specialty",
        name: "EditContentSpecialty",
        component: () =>
          import(
            /* webpackChunkName: "content-pages" */ "@/views/Content/pages/Specialties/Register"
          ),
      },
    ],
  },
];
